import React from 'react';
import PropTypes from 'prop-types';
import withData from '@bd/bdcore-data';
import PageHelmet from '@bd/bdcore-pagehelmet';
import PageWrapper from '../../components/PageWrapper';
import InsideHeader from '../../components/InsideHeader';

function Blogposts({ page }) {
  return (
    <PageWrapper>
      <PageHelmet page={page} />
      <InsideHeader h1="Blogposts" />
    </PageWrapper>
  );
}

Blogposts.propTypes = {
  page: PropTypes.object.isRequired,
};

export default withData({
  page: 'blogposts',
})(Blogposts);



// WEBPACK FOOTER //
// ./src/pages/Blogposts/index.js